import { useLocale } from '~/composables/useLocale'
import { useNotificationCenter } from '~/composables/useNotificationCenter'

/** Regroupe les « œufs prêts » pour éviter un toast par slot pendant le farm. */
const READY_EGGS_DEBOUNCE_MS = 5_000

let pendingReadyEggCount = 0
let readyEggsFlushTimer: ReturnType<typeof setTimeout> | null = null

export function useDaycareHatchToasts() {
  const { notify } = useNotificationCenter()
  const { t } = useLocale()

  function flushReadyEggsToast() {
    readyEggsFlushTimer = null
    const n = pendingReadyEggCount
    pendingReadyEggCount = 0
    if (n <= 0) return
    notify(
      'daycare',
      t(
        `${n} œuf${n > 1 ? 's' : ''} prêt${n > 1 ? 's' : ''} à éclore !`,
        `${n} egg${n > 1 ? 's' : ''} ready to hatch!`,
      ),
      { icon: '🥚', coalesceKey: 'eggs-ready' },
    )
  }

  /** Hors collecte auto : un seul toast après une courte fenêtre. */
  function queueReadyEggsToast(diff: number) {
    if (diff <= 0) return
    pendingReadyEggCount += diff
    if (readyEggsFlushTimer) clearTimeout(readyEggsFlushTimer)
    readyEggsFlushTimer = setTimeout(flushReadyEggsToast, READY_EGGS_DEBOUNCE_MS)
  }

  function notifyShinyHatched(nameFr: string, nameEn: string) {
    notify('shiny', t(`✨ Shiny éclos : ${t(nameFr, nameEn)} !`, `✨ Shiny hatched: ${t(nameFr, nameEn)}!`), {
      icon: '✨',
      type: 'success',
      duration: 8000,
      // Clé distincte de « shiny-obtained » (célébration inventaire) pour ne pas fusionner / doubler.
      coalesceKey: 'shiny-hatch',
    })
  }

  return { queueReadyEggsToast, notifyShinyHatched }
}
